import * as firebase from "firebase";
import flamelink from "flamelink";

// Initialize Firebase
const config = {
  apiKey: "AIzaSyCtXIon6w8MiOIwlhUs416WO2YdF_fNULw",
  authDomain: "thermbond-5b94f.firebaseapp.com",
  databaseURL: "https://thermbond-5b94f.firebaseio.com",
  projectId: "thermbond-5b94f",
  storageBucket: "thermbond-5b94f.appspot.com",
  messagingSenderId: "1019189116679",
};

const firebaseApp = firebase.initializeApp(config);

const app = flamelink({
  firebaseApp,
  env: "production",
  locale: "en-US",
  dbType: "cf",
});

export default app;
